import PokerTablePokerBase from "./poker_table_poker_base";

const { ccclass, property, menu } = cc._decorator;

const const_color_config = {
    [1]: 'color_black_heart',
    [2]: 'color_red_heart',
    [3]: 'color_plum',
    [4]: 'color_square',
}

@ccclass
export default abstract class PokerTableAssemblyPokerBase extends PokerTablePokerBase{
    @property(cc.Sprite)
    spritePoint: cc.Sprite = null

    @property(cc.Sprite)
    spriteColor: cc.Sprite = null

    @property(cc.Sprite)
    spriteBigColor: cc.Sprite = null    

    protected setFace(code: number){
        let data = this.calcColorPoint(code)
        this.setPoint(data)
        this.setColor(data)
    }

    protected abstract calcColorPoint(code: number): {point: number, color: number};
    protected abstract isRedColor(color: number): boolean;
    protected isBlackColor(color: number): boolean{
        return !this.isRedColor(color)
    }

    protected getPointSpriteFrame(point: number, color: number){
        let tmp = ''
        if(this.isRedColor(color)){
            tmp = 'red_'
        }else if(this.isBlackColor(color)){
            tmp = 'black_'
        }else{

        }
        let key = `point_${tmp}${point}`
        return this.getSpriteFrameByName(key)
    }

    protected getColorSpriteFrame(color: number, point: number){
        let key = `${const_color_config[color]}_small`
        return this.getSpriteFrameByName(key)
    }

    protected getBigColorSpriteFrame(color: number, point: number){
        let key = `${const_color_config[color]}_big`
        if(point > 10){
            key = `${const_color_config[color]}_${point}`
        }
        return this.getSpriteFrameByName(key)
    }

    protected setPoint(data: {point: number, color: number}){        
        if(this.spritePoint){
            this.spritePoint.spriteFrame = this.getPointSpriteFrame(data.point, data.color)
        }
    }
    

    protected setColor(data: {point: number, color: number}){        
        if(this.spriteColor){
            this.spriteColor.spriteFrame = this.getColorSpriteFrame(data.color, data.point)
        }
        if(this.spriteBigColor){
            this.spriteBigColor.spriteFrame = this.getBigColorSpriteFrame(data.color, data.point)
        }
    }

    setPokerGrayColor(gray: boolean){
        super.setPokerGrayColor(gray)
        if(gray){
            let color = cc.color(128, 128, 128, 255)
            this.spritePoint && (this.spritePoint.node.color = color.clone())
            this.spriteColor && (this.spriteColor.node.color = color.clone())
            this.spriteBigColor && (this.spriteBigColor.node.color = color.clone())
        }else{
            this.spritePoint && (this.spritePoint.node.color = this.original_color)
            this.spriteColor && (this.spriteColor.node.color = this.original_color)
            this.spriteBigColor && (this.spriteBigColor.node.color = this.original_color)
        }
    }
}
